import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import en from './locales/en.json';
import mi from './locales/mi.json';
import zh from './locales/zh.json';
import hi from './locales/hi.json';
import ko from './locales/ko.json';
import ja from './locales/ja.json';
import tl from './locales/tl.json';
import sm from './locales/sm.json';
import to from './locales/to.json';
import fj from './locales/fj.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import es from './locales/es.json';

const resources = {
  en: { translation: en },
  mi: { translation: mi },
  zh: { translation: zh },
  hi: { translation: hi },
  ko: { translation: ko },
  ja: { translation: ja },
  tl: { translation: tl },
  sm: { translation: sm },
  to: { translation: to },
  fj: { translation: fj },
  fr: { translation: fr },
  it: { translation: it },
  es: { translation: es }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'levr_language',
      caches: ['localStorage']
    }
  });

export default i18n;
